import { defineAsyncComponent } from 'vue';

export default {
    slug: 'timesheets',
    ability: 'timesheets',
    components(app) {
        app.component(
            'app-timesheets',
            defineAsyncComponent(() => import('./components/Timesheets.vue'))
        );

        // Shown in the top bar while a punch is counting — see RunningClock.vue.
        app.component(
            'app-running-clock',
            defineAsyncComponent(() => import('./components/RunningClock.vue'))
        );
    },
    routes: [
        {
            path: 'timesheets',
            name: 'timesheets',
            component: () => import('@modules/Timesheets/Resources/js/pages/Index.vue'),
            // What the list asks for as it opens, in one request (utils/listBootstrap.js).
            meta: { listBootstrap: { list: 'timesheets' } }
        },
        {
            // Reached from the Payroll settings grid: the catalogue types both
            // time entries and absences, and payroll is where an org configures.
            path: 'timesheets/settings/time-types',
            name: 'timesheets-time-types',
            component: () => import('@modules/Timesheets/Resources/js/pages/settings/TimeTypes.vue')
        }
    ],
    widgets: () => [
        {
            id: 'timesheet-summary',
            label: i18n.t('Timesheet Summary'),
            icon: 'clock-check-outline',
            component: () => import('@modules/Timesheets/Resources/js/pages/widgets/TimesheetSummary.vue'),
            size: 'is-6'
        }
    ],
    nav: () => ({
        section: 'projects',
        items: [
            {
                title: i18n.t('Timesheets'),
                icon: 'clock',
                to: { name: 'timesheets' }
            }
        ]
    })
};
